import {
  Show as DiscoverFeedSchema,
  TInnovator,
  TShow,
  TSolutionListing,
} from "./__generated__/mochitypes/discover_feed/show";

export type DiscoverFeedResponse = Omit<TShow, "listings"> & {
  listings: DiscoverSolutionListing[];
};
export type DiscoverSolutionListing = TSolutionListing & { logo_url?: string | null };
export type DiscoverInnovator = TInnovator;

// Re-exported schema for runtime validation where needed
export const DiscoverFeedZodSchema = DiscoverFeedSchema;
